import JobOffer from './JobOffer'
export default JobOffer
